module.exports = __webpack_public_path__ + "static/media/13.e153ee70.png";